'use strict';

const QueryString = require('../rlink-querystring');

exports.parseResponseHeaders = function parseResponseHeaders (headerStr) {
  let headers = {};

  if (!headerStr) {
    return headers;
  }

  let headerPairs = headerStr.split('\u000d\u000a');

  for (let i = 0, ilen = headerPairs.length; i < ilen; i++) {
    let headerPair = headerPairs[i];
    let index = headerPair.indexOf('\u003a\u0020');

    if (index > 0) {
      let key = headerPair.substring(0, index);
      let val = headerPair.substring(index + 2);
      headers[key] = val;
    }
  }

  return headers;
};

exports.processCommonHeaders = function processCommonHeaders (headers) {
  if (headers['Content-Type']) {
    let [contentType, paramsPortion = false] = headers['Content-Type'].split(/; */);
    let contentParams = {};

    if (paramsPortion) {
      let qs = new QueryString(paramsPortion);
      contentParams = qs.toSingleValueDict();
    }

    let [type, subtype] = contentType.split('/');
    headers['Content-Type'] = {
      contentType,
      type,
      subtype,
      params: contentParams,
    };
  }

  return headers;
};

exports.xhr = function xhr (method, url, data, options = {}) {
  options = Object.assign({withCredentials: true}, options);

  return new Promise((resolve, reject) => {
    let xhReq = new global.XMLHttpRequest();
    xhReq.withCredentials = options.withCredentials;
    let body = false;
    let contentType = options.contentType;

    if (data) {
      if (contentType) {
        // user provided content type
        if (contentType === 'application/json') {
          if (options.prettyJSON) {
            body = JSON.stringify(data, null, '  ');
          } else {
            body = JSON.stringify(data);
          }
        } else {
          // we assume you know what you're doing...
          body = data;
        }
      } else if (Array.isArray(data)) {
        // use multipart!
        let boundry = `rlink-${Date.now().toString(16)}`;
        contentType = `multipart/form-data; boundary=${boundry}`;
        let parts = [];

        for (let [headers, blob] of data) {
          parts.push(`\r\n--${boundry}\r\n`);

          for (let headerName in headers) {
            parts.push(`${headerName}: ${headers[headerName]}\r\n`);
          }

          parts.push('\r\n');

          if (headers['Content-Type'] === 'application/json' && typeof blob !== 'string') {
            if (options.prettyJSON) {
              parts.push(JSON.stringify(blob, null, '  '));
            } else {
              parts.push(JSON.stringify(blob));
            }
          } else if (blob instanceof Blob) {
            parts.push(new Promise((innerResolve, _) => {
              let reader = new FileReader();
              reader.onload = (ev => {
                innerResolve(ev.target.result);
              });
              reader.readAsArrayBuffer(blob);
            }));
          } else {
            parts.push(blob);
          }
        }

        parts.push(`\r\n--${boundry}--\r\n`);
        body = Promise.all(parts);
      } else {
        // normal form data
        contentType = 'application/x-www-form-urlencoded';

        let qs = new QueryString(data);

        if (method === 'GET' || method === 'HEAD' || method === 'OPTIONS') {
          url = `${url}?${qs.toString()}`;
        } else {
          body = qs.toString();
        }
      }
    }

    xhReq.open(method, url);
    let responseType = options.responseType;

    if (responseType) {
      xhReq.responseType = responseType;
    }

    if (body) {
      xhReq.setRequestHeader('Content-Type', contentType);

      if (body instanceof Promise) {
        body.then(parts => xhReq.send(new Blob(parts)));
      } else {
        xhReq.send(body);
      }
    } else {
      xhReq.send();
    }

    xhReq.onerror = reject;

    xhReq.onload = (() => {
      let response = xhReq.response;
      if (typeof (response) === 'string' && responseType === 'json') {
        response = JSON.parse(response);
      }

      resolve({
        response,
        status: xhReq.status,
        headers: exports.processCommonHeaders(
          exports.parseResponseHeaders(
            xhReq.getAllResponseHeaders())),
      });
    });
  });
};

let jsonpCounter = 0;

exports.jsonp = function jsonp (callbackParam, url, data) {
  return new Promise((resolve, _) => {
    jsonpCounter++;
    let callbackName = `rlink_jsonp_cb_${jsonpCounter}`;
    data[callbackParam] = callbackName;
    let query = QueryString.makeQuery(data);

    if (query.length > 0) {
      if (/\?/.test(url)) {
        url = `${url}&${query.slice(1)}`;
      } else {
        url = url + query;
      }
    }

    let scriptEl = global.document.createElement('script');
    scriptEl.setAttribute('src', url);

    global.window[callbackName] = function (result) {
      resolve({text: result});
      delete global.window[callbackName];
      document.body.removeChild(scriptEl);
    };

    document.body.appendChild(scriptEl);
  });
};



// WEBPACK FOOTER //
// ./lib/rlink-utils/xhr.js